import React from "react";

const Copyright = () => (
  <footer id="copyright" className="section-wrapper">
    <p>&copy; 2023 Richard W Lee.</p>
  </footer>
);

export default Copyright;
